import React, { useContext } from "react";
import Select from "../../ui/Select/Select";
import GlobalsContext from "../../context/GlobalsContext";

const GroupSelect = props => {
  const globalsContext = useContext(GlobalsContext);

  return <Select {...props} options={globalsContext.rb_groups} />;
};

export default GroupSelect;
